export default __webpack_public_path__ + "static/media/9dc47b30a30f836d4072ba8ae03752171582283300514.ceef45a5.webp";